"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("../enum");
const previewsSchema = new mongoose_1.Schema({
    name: String,
    project: {
        ref: "Project",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    server: {
        ref: "Server",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    healthCheckPath: {
        type: String,
        required: false,
    },
    pid: Number,
    port: Number,
    ip: String,
    dir: String,
    branch: String,
    issue_comment_id: Number,
    status: {
        type: String,
        enum: Object.values(enum_1.PROJECT_STATUS),
        default: enum_1.PROJECT_STATUS.PENDING,
    },
    log: {
        ref: "Log",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    last_requested: mongoose_1.Schema.Types.Date,
    isPaused: Boolean,
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("Preview", previewsSchema);
